<template>
    <BannerTemplate :bannerSource="bannerSource" :title="`Galerij en reviews`" :intro="intro">
        <LoadingIcon :isLoading="isLoading" />
        <v-container class="px-5 gallery-en-reviews">
            <v-row>
                <horizontal-scroll class="horizontal-scroll">
                    <div class="outer">
                        <template v-for="event in events" >
                            <div class="inner-content" :key="event.roadtripLabel">
                                <v-container>
                                    <v-row>
                                        <v-col class="col-12 photo-header py-0">{{event.roadtripLabel}}</v-col>
                                        <v-col class="col-12 rating px-3 pt-0 mt-n1 mb-2 d-flex">
                                           <v-rating
                                                v-model="event.averageRating"
                                                background-color="#b5b5b5"
                                                color="yellow accent-4"
                                                half-increments
                                                dense
                                                readonly
                                                size="22"></v-rating>
                                            <div class="comments">{{event.averageRating}} <span class="pl-1">({{event.numberOfRatings}})</span></div>
                                        </v-col>
                                    </v-row>
                                    <ImageRedirect @imgClick="goToGallery(event.roadtripLabel)" :imageSource="event.galleryImageURL" />
                                    <v-row>
                                        <v-col>
                                            <p class="details">{{event.galleryText}}</p>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </template>
                    </div>
                </horizontal-scroll>
            </v-row>
        </v-container>
    </BannerTemplate>
</template>

<script>
import LoadingIcon from '@/components/common/LoadingIcon';
import ImageRedirect from '@/components/common/ImageRedirect';
import HorizontalScroll from 'vue-horizontal-scroll';
import BannerTemplate from '@/components/common/BannerTemplate';
import RouteMixin from '@/mixins/route.mixin';
import MetaTagsMixin from '@/mixins/metatags.mixin';

import 'vue-horizontal-scroll/dist/vue-horizontal-scroll.css';

export default {
    name: 'GalerijEnReviews',
    components: 
    {
        LoadingIcon,
        HorizontalScroll,
        ImageRedirect,
        BannerTemplate
    },
    mixins: [RouteMixin, MetaTagsMixin],
    data: () => ({
        bannerSource:  require('@/assets/album/gallery_reviews_cover.jpg'),
        intro: "Een verzameling van mooie herinneringen, avontuurlijke roadtrips en bijzondere voertuigen, gesorteerd per roadtrip-categorie. Rijdt u de volgende keer ook mee? Laat u overtuigen door de prachtige foto's!",
        isLoading: false,
        events: [],
    }),
    mounted () 
    {
        this.$store.commit('setFooterVisibility', true);
        this.getGalleries();
    },
    metaInfo() {
        return {
        title: "| Galerij en review",
        meta: [
            this.getKeywords(`Volvo, Porsche, BMW, Audi, Mercedes, Mix, Galerij, foto's, media, reviews`),
            this.getMetaDescription(`Roadpursuit Galerij en reviews`),
            this.getAuthor(),
            ...this.getSocialMediaMetas('Roadpursuit Galerij en reviews', 'Volvo, Porsche, en Mix galerijen en reviews', `${window.location.origin}${this.bannerSource}`, 'Roadpursuit galerijen en Reviews')
        ]
        };
    },
    methods: {
        getGalleries()
        {
            this.isLoading = true;
            this.$store.dispatch('galleryModule/getGalleries', this.roadtripId)
                .then(data => {
                this.events = data;
                this.isLoading = false;
            })
            .catch(() => { this.isLoading = false; });
        },
    }
  }
</script>

<style>

.gallery-en-reviews .horizontal-scroll {
    display: flex;
    width: 100%;
    height: 450px;
}

.outer {
    display: flex;
    flex: 1;
    width: auto;
    height: 100%;
    flex-flow: row nowrap;
}

.inner-content {
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 280px;
    color: white;
    border-radius: 5px;
}

.inner-content:not(:first-of-type) {
    margin-left: 10px;
}

p.details
{
    overflow: hidden;
    overflow-wrap: break-word;
    word-break: unset;
    white-space: break-spaces;
    text-overflow: ellipsis;
}

</style>
